import * as UserSelectors from "../User/User.selector";
import * as Flags from "../../lib/Flags";
import { StoreState } from "../RootReducer";

export const selectIsMobile = (state: StoreState) => state.Global.mobile;

export const isMobileNavVisible = (state: StoreState) =>
	state.Global.mobileNavVisible;

export const getLoadingOverlay = (state: StoreState) =>
	state.Global.loadingOverlay;

export const isDemoModeEnabled = (state: StoreState) => false;
